module.exports = __webpack_public_path__ + "images/emoji/mans_shoe.e0adac2047ad9248d5cd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mans_shoe.png
// module id = +HFB
// module chunks = 13